export default __webpack_public_path__ + "static/media/tripleCubes.61a57ea4.svg";